import { css, etiColors } from '@eti/styles';
import { Icon } from '@eti/components';
import { jsx as _jsx } from "react/jsx-runtime";
const styles = css`
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 50%;
  opacity: 1;
  position: absolute;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  transition: opacity 0.5s;
  width: 100%;

  & > svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;
const Ban = () => /*#__PURE__*/_jsx("span", {
  className: styles,
  "data-testid": "seatMap-stepIndicatorItem-Ban",
  children: /*#__PURE__*/_jsx(Icon, {
    color: etiColors.white,
    id: "ban"
  })
});
export default Ban;